import { Anchor, Badge, Center, Group, Stack, Text } from "@mantine/core";
import { IconArrowRight } from "@tabler/icons-react";
import { ReactNode } from "react";
import { Link } from "react-router-dom";

import { OrdersSummaryTable } from "/@/components/order/OrdersSummaryTable";
import type {
  MaterialAndShadeCatalog,
  OrdersListOrder,
} from "@jasper/use-cases";

export const OrdersTable = ({
  title,
  icon,
  hint,
  orders,
  materialAndShadeCatalog,
  emptyLabel,
}: {
  title: string;
  icon: ReactNode;
  hint?: string;
  orders: OrdersListOrder[];
  materialAndShadeCatalog: MaterialAndShadeCatalog;
  emptyLabel: string;
}) => (
  <Stack gap="xs">
    <Group gap="xs" align="center">
      <Center c="ink.8">{icon}</Center>
      <Text variant="strong">{title}</Text>
      {hint && (
        <Badge variant="tag" color="ink" tt="none" c="ink.4">
          {hint}
        </Badge>
      )}
      <Anchor
        component={Link}
        to="/orders"
        ml="auto"
        size="sm"
        fw={600}
        c="brand.6"
      >
        <Group gap={4} align="center">
          Toutes les commandes
          <IconArrowRight size={14} />
        </Group>
      </Anchor>
    </Group>
    <OrdersSummaryTable
      orders={orders}
      materialAndShadeCatalog={materialAndShadeCatalog}
      emptyMessage={emptyLabel}
    />
  </Stack>
);
